/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonTemplate,
    JsonTemplateFromJSON,
    JsonTemplateFromJSONTyped,
    JsonTemplateToJSON,
} from './JsonTemplate';

/**
 * 
 * @export
 * @interface ApiResultOfJsonTemplate
 */
export interface ApiResultOfJsonTemplate {
    /**
     * 
     * @type {JsonTemplate}
     * @memberof ApiResultOfJsonTemplate
     */
    data?: JsonTemplate;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonTemplate
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonTemplate
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonTemplate
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonTemplate
     */
    result?: ApiResultOfJsonTemplateResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonTemplateResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonTemplateFromJSON(json: any): ApiResultOfJsonTemplate {
    return ApiResultOfJsonTemplateFromJSONTyped(json, false);
}

export function ApiResultOfJsonTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonTemplate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonTemplateFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonTemplateToJSON(value?: ApiResultOfJsonTemplate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonTemplateToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

